import { useEffect, useState } from "react";
import { ListingCard } from "@/components/ListingCard";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";

export const ForYou = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    (async () => {
      const viewed = JSON.parse(localStorage.getItem("bazaro_viewed_cats") || "[]");
      const [{ data: all }, favs] = await Promise.all([
        api.get("/listings"),
        user ? api.get("/favorites").then((r) => r.data).catch(() => []) : Promise.resolve([]),
      ]);
      const prefs = new Set([...viewed, ...favs.map((f) => f.category)]);
      const picked = all.filter((l) => prefs.has(l.category) && !user?.favorites?.includes(l.id) && l.seller_id !== user?.id);
      setItems((picked.length ? picked : all).slice(0, 12));
    })().catch(() => setItems([]));
  }, [user]);

  if (items === null) return <div className="h-40 mb-8" />;
  if (!items.length) return <div className="text-center py-6 text-slate-500 text-sm bg-white/60 rounded-3xl mb-8" data-testid="for-you-empty">{t("for_you_empty")}</div>;
  return (
    <div className="flex gap-4 overflow-x-auto no-scrollbar pb-1 mb-8" data-testid="for-you-list">
      {items.map((l) => <div key={l.id} className="w-44 sm:w-52 shrink-0"><ListingCard listing={l} /></div>)}
    </div>
  );
};
